export default "* Følelser";